export const classSuspensionFlow = {
	MODAL_SUSPENSION: 1,
	WARNING: 2,
};